import React from "react";

export interface BreadcrumbItem {
	label?: string;
	origin?: string;
}
type IContext = {
	breadcrumb: BreadcrumbItem[];
	setBreadcrumb: (value: BreadcrumbItem[]) => void;
};

const BreadcrumbContext = React.createContext<IContext>({
	breadcrumb: [],
	setBreadcrumb: () => {},
});

export default BreadcrumbContext;
